export class TestFakeDb
{
    public static tests = [
        {  
            'SiteId':'1000001',
            'ClientId':'1',
            'AccountNum':'429699',
            'SiteType':'Fire Commercial',
            'Company':'BRANDYWINE PORCHE',
            'Address':'4005 WEST CHESTER PKE',
            'City':'Sayre',
            'State':'PA',	
            'ZIP':'18840',
            'Country':'USA',
            'SiteUse':'InUse',
            'PremideID':'12698',
            'HazardID':'1235',
            'SerialNo':'596561',
            'DeviceStatus':'Installed',
            'Installed Date':'02/12/1987',
            'TestID':'1001',
            'TesterID':'596562',
            'TestStatus':'Pass',
            'TestDueDate':'02/12/1987',
            'TestDate':'02/12/1984',
            'TestType':'Demo Test Type',
            'TesterName':'Stevie',
            'TestKit':'Mid-West Instruments',
            'LinePSI':'305770',
            'Notes':'Test Note',
            'Flag':'Test Flag',
            'UDT':'sfickle',
            'Value1':'Test Value1',
            'Value2':'Test Value2',
            'Relief':'Relief Test',
            'Buffer':'Buffer Test',
            'TestDue':'02/12/2017',
            'ScheduleDate':'02/12/2017',
            'Notice1':'Sent',
            'Notice2':'Sent',
            'Notice3':'None',
            'Notice4':'None'

         },
         {  
            'SiteId':'1000001',
            'ClientId':'2',
            'AccountNum':'91573',
            'SiteType':'Fire Commercial',
            'Company':'JOHN MIDDLETON',
            'Address':'416 MORRIS AVE',
            'PremideID':'12699',
            'HazardID':'1235',
            'SerialNo':'596562',
            'DeviceStatus':'Installed',
            'Installed Date':'03/12/1987',
            'TestID':'1235',
            'TesterID':'1002',
            'TestStatus':'Pass',
            'TestDueDate':'02/12/1987',
         },
         {  
            'SiteId':'1000001',
            'ClientId':'3',
            'AccountNum':'91574',
            'SiteType':'Fire Commercial',
            'Company':'JOHN MIDDLETON',
            'Address':'416 MORRIS AVE',
            'PremideID':'12691',
            'HazardID':'1235',
            'SerialNo':'596563',
            'DeviceStatus':'Installed',
            'Installed Date':'04/12/1987',
            'TestID':'1003',
            'TesterID':'596562',
            'TestStatus':'Pass',
            'TestDueDate':'02/12/1987',
         },
         {  
            'SiteId':'1000001',
            'ClientId':'4',
            'AccountNum':'91574',
            'SiteType':'Fire Commercial',
            'Company':'JOHN MIDDLETON',
            'Address':'416 MORRIS AVE',
            'PremideID':'12692',
            'HazardID':'1235',
            'SerialNo':'596565',
            'DeviceStatus':'Installed',
            'Installed Date':'04/12/1987',
            'TestID':'1004',
            'TesterID':'596562',
            'TestStatus':'Pass',
            'TestDueDate':'02/12/1987',
         },
    ];

}
